<script>
import {
  getFirestore,
  doc,
  getDoc,
} from 'firebase/firestore/lite'
import { firebase } from '../firebase-int'

const firestore = getFirestore(firebase)
/**
 * Left sidebar component - contains mainly the application menu
 */
export default {
  props: {
    qfcontent: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    correctText: {
      type: String,
      required: false,
      default: () => ({}),
    },
    toolId: {
      type: String,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      settings: {
        minScrollbarLength: 60,
      },
      tool: null,
      loadingData: true,
      isToolOkay:false
    }
  },
  methods: {
    getAccessLevelColor(item) {
      if (item === 'Administrator') return 'badge-soft-danger'
      else if (item === 'Editor') return 'badge-soft-secondary'
      else if (item === 'User') return 'badge-soft-success'
      else if (item === 'Union Administrator') return 'badge-soft-primary'
      else if (item === 'Federation Administrator') return 'badge-soft-info'
      else return 'badge-soft-dark'
    },
    myRowClickHandler(content) {
      console.log(content.id + ' - ' + content.title + ' - ' + content.story) // This will be the item data for the row
      this.$router.push({
        name: 'SubChapters',
        params: { content: content, id: content.id },
      })
    },
    handleClick() {
      this.$emit("send")
    },

    async getToolDetails() {
      var docRef = null
      var tempList = []
      docRef = doc(firestore, 'tool', this.toolId)

      const docSnap = await getDoc(docRef)

      if (docSnap.exists()) {
        this.tool = docSnap.data()
        this.tool.id = docSnap.id
      } else {
        // doc.data() will be undefined in this case
        console.log('No such document!')
      }

      //this.questionFeedbackObjectsList=tempList;
      this.loadingData = false
    },
    showToolDialog()
    {
      //console.log('>>>>>>>>>>>..inside feedback: '+this.tool.tip)
      this.$emit('showTool', this.tool)
    },
    checkToolContent()
    {
      if(this.tool.description.length > 0 || this.tool.tip.length > 0)
      {
        if(!this.tool.description.includes('?') && !this.tool.tip.includes('?'))
        this.isToolOkay=true
      }

    }

  },
  computed: {},
  watch: {},
  async mounted() {
    //console.log('>>>>>> Tool: ' + this.toolId)
    if (this.toolId.length > 4)
      await this.getToolDetails()
    this.checkToolContent()
  },
}
</script>

<template>
  <!--div
    class="column column-class"
    style="
      position: relative;
      top: 50%;
      transform: translateY(-50%);
      justify-content: center;
      padding:4em
    "
  >
    <div><h3>{{ qfcontent.title }}</h3></div>
    <div><h5>{{ qfcontent.description }}</h5></div>
    
  </div-->
  <!-- background-color: #EFFFDF -->
  <div class="row row-class" style="padding:4em;">
    <div class="col-md-2 col-lg-2 col-sm-12 col-xl-2" style="padding-top: 1em;">
      <img src="../assets/images/feedback.png" class="imageClass" style="margin-right: auto; display: block;" />
      <!--img src="../assets/images/idea.png" class="imageClass" style="margin-right: auto; display: block;" /-->

    </div>
    <div class="col-md-10 col-lg-10 col-sm-12 col-xl-10">
      <div v-if="correctText.length">
        <h3>{{ correctText }}</h3>
      </div>
      <div>
        <h4>{{ qfcontent.description }}</h4>
      </div>
      <div v-if="this.toolId.length > 4 && this.tool" style="padding-top:4px; padding-bottom:4px; padding-left:10px"
        class="row">
        <a v-if="isToolOkay" @click="showToolDialog"><img src="../assets/images/tool_icon.png"
          width="50" height="50" style=" display: block; cursor: pointer;" /></a>
        <h6>&nbsp;&nbsp;</h6>
        <a v-if="this.tool.link.length > 0" :href="this.tool.link" target="_blank"><img src="../assets/images/link_icon.png" width="50"
            height="50" style=" display: block;" /></a>
      </div>
      <div style="margin-top: 10px">
        <b-button variant="primary" class="text-left" @click="handleClick()">Continue</b-button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
/* xs */
.imageClass {
    width: 100px;
    height: auto;
}
/* sm */
@media (min-width: 768px) {
    .imageClass {
        width: 50px;
    }
}
/* md */
@media (min-width: 992px) {
    .imageClass {
        width: 80px;
    }
}
/* lg */
@media (min-width: 1200px) {
    .imageClass {
        width: 100px;
    }
}

#textbox {
  display: flex;
  flex-flow: row wrap;
}

.alignleft {
  width: 50%;
  text-align: left;
  font-weight: 100;
  font-size: 12px;
  line-height: 10px;
  color: white;
}

.alignright {
  width: 50%;
  text-align: right;
  font-weight: 100;
  font-size: 12px;
  line-height: 10px;
  color: white;
}

.cardd {
  height: 350px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(10px);
  position: relative;
  border-radius: 16px;
  margin-bottom: 16px;
  //box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
}

.card-img {
  height: 350px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(10px);
  position: relative;
  margin: 0px auto 0px auto;
  left: 0;
  right: 0;
  border-radius: 16px;
}

.card-img img {
  height: 100%;
  width: 100%;
  border-radius: 16px;
  object-fit: cover;
}

.desc {
  width: 100%;
  text-align: left;
  position: absolute;
  top: 16px;
  left: 16px;
}

.primary-text {
  color: #ffffff;
  font-size: 18px;
  font-weight: 300;
  letter-spacing: 0.7px;
  margin: 5px 0;
  text-shadow: 1px 1px #000000;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.secondary-text {
  color: #ffffff;
  font-weight: 100;
  font-size: 12px;
  letter-spacing: 1px;
  margin: 5px 0;
  text-overflow: ellipsis;
  overflow: hidden;
  // Addition lines for 2 line or multiline ellipsis
  display: -webkit-box !important;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  white-space: normal;
}

.coveredSoFar {
  width: 100%;
  font-weight: 100;
  font-size: 12px;
  line-height: 30px;
}

.bottom {
  width: 100%;
  display: inline-block;
  align-self: flex-end;
}

.details {
  width: 100%;
  height: 50%;
  position: absolute;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.185);
  backdrop-filter: blur(10px);
  border-radius: 0 0 16px 16px;
  padding: 15px;
  display: flex;
}

.details>div {
  text-align: left;
}

.buttonn {
  background-color: rgba(0, 0, 0, 0.06);
  backdrop-filter: blur(10px);
  position: absolute;
  width: 80%;
  left: 10%;
  top: 240px;
  border: none;
  border-radius: 5px;
  padding: 15px 0;
}

.coffe {
  position: absolute;
  left: 50px;
  bottom: 50px;
  transition: all 0.6s ease-in-out;
}

.coffe:hover {
  transform: scale(1.2);
}

.fs-12 {
  font-size: 10px !important;
}

.custom_badge {
  display: inline-block;
  padding: 0.25 em 0.4 em;
  font-size: 70%;
  font-weight: 500;
  line-height: 1.2;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.75 rem;
}

.custom_card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1 px solid #e2e7f1;
  border-radius: 0.25 rem;
}

.custom_img {
  border-radius: 16px 16px 0px 0px;
  object-fit: contain;
  display: flex;
  width: 100%;
  height: 100%;
}

.custom_loader_img {
  border-radius: 5px 5px 0px 0px;
  height: 140px;
  object-fit: scale-down;
  display: block;
  width: 100%;
}

.custom_card-body {
  flex: 1 1 auto;
  padding: 15px 25px 5px 0px;
}

.custom_align-items-left {
  align-items: left !important;
}

.col-sm-auto {
  flex: 0 0 auto;
  width: auto;
}
</style>
